<div class="property-description-page__grid-container">
    <property-about-section class="property-description-page__about-section">
    </property-about-section>
    <property-side-card
        class="property-description-page__side-card"
        [icon]="sideCardIcon"
        [heading]="sideCardHeading"
    >
        <div class="property-description-page__side-card-description">
            <p>What’s the neighbourhood like?</p>
            <p>Are there any renovations or outstanding features?</p>
            <p>How big are the bedrooms?</p>
            <p>What type of heating and insulation is installed?</p>
            <p>Is there a view from the property?</p>
        </div>
    </property-side-card>
    <property-rental-attribute-section
        class="property-description-page__attribute-section"
    >
    </property-rental-attribute-section>
</div>
